import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import { SearchBar } from "components";
import { InputSimpleDropdown, PrimaryButton } from "@loanbossinc/component-library";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding: 2em 0;
  gap: 1em;
  min-height: 60%;
  background-color: #FFFFFF;
  max-width: ${(({ maxWidth }) => maxWidth ?? "1920px")};
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputDropdownWrapper = styled.div`
  font-family: Work Sans;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const SearchContainerLeft = styled.div`
  display: flex;
  width: 50%;
`;

const SearchContainerRight = styled.div`
  display: flex;
  width: 50%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 1em;
`;

export const EdcIndividualFilterBar = ({
  searchText,
  companies,
  onSearchTextUpdate: handleOnSearchUpdate,
  selectedFilterCompany,
  onUpdateFilterCompany: handleUpdateFilterCompany,
  onSendNowClicked: handleSendNowClicked
}) => {
  const [search, setSearch] = useState("");
  const buttonStyles = { borderRadius: "8px", border: "none", backgroundColor: "#005AA9" };

  useEffect(() => {
    handleOnSearchUpdate(search);
  }, [search, handleOnSearchUpdate]);

  return (
    <Container>
      <FilterWrapper>
        <InputDropdownWrapper>
          <InputSimpleDropdown
            name="edcIndividualCompanyDropdown"
            value={selectedFilterCompany}
            label="Filter by Company"
            options={companies}
            onChange={handleUpdateFilterCompany}
          />
        </InputDropdownWrapper>
        <SearchContainer>
          <SearchContainerLeft>
            <SearchBar
              marginLeft={0}
              searchText={search}
              setSearchText={setSearch}
              placeholder={searchText}
            />
          </SearchContainerLeft>
          <SearchContainerRight>
            <PrimaryButton
              label="Send Now"
              onClick={handleSendNowClicked}
              style={{ width: "150px", ...buttonStyles }}
            />
          </SearchContainerRight>
        </SearchContainer>
      </FilterWrapper>
    </Container>
  );
};
